import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ScanStatus} from "../../../model";

@Component({
    selector: 'app-po-split-dialog',
    templateUrl: './po-split-dialog.component.html',
    styleUrls: ['./po-split-dialog.component.scss'],
    standalone: false
})
export class PoSplitDialogComponent {

  @Input()
  maxCount: number = 1;

  @Input()
  minCount: number = 1;

  @Output()
  onCancel = new EventEmitter<void>();

  @Output()
  onUpdate = new EventEmitter<number>();

  isVisible: boolean = false;
  value: number = this.minCount;


  public show(){
    this.value = this.minCount;
    this.isVisible = true;
  }

  onOk() {
    this.onUpdate.emit(this.value);
    this.isVisible = false;
  }

  cancel() {
    this.onCancel.emit();
    this.isVisible = false;
  }
}
